<template>
  <div id="apply">
    <div class="steps-card">
      <div class="steps">
        <steps v-model="activeStep.index" :status="activeStep.status" :options="steps"></steps>
      </div>
      <div v-if="enterState === 'SIGN_FAILED'" class="errors auto1200">
        <p>很遗憾，入驻失败了，如有问题，可联系项目经理，并发起 <a @click="showStartoverDlg">重新入驻</a></p>
        <p v-show="errorMsg" class="error-msg">失败原因：{{ errorMsg }}</p>
      </div>
    </div>
    <div class="main">
      <stage-filling v-if="activeStep.index === 0"></stage-filling>
      <stage-audit v-if="activeStep.index === 1"></stage-audit>
      <stage-agreement v-if="activeStep.index === 2"></stage-agreement>
      <stage-entered v-if="activeStep.index === 3"></stage-entered>
    </div>

    <el-dialog
      class="startover-dlg"
      title="重新入驻"
      width="406px"
      :visible="startoverDlg.visible"
      @close="startoverDlg.visible = false"
    >
      <div class="content">
        <p>是否保留上次入驻信息</p>
        <el-radio-group v-model="startoverDlg.value">
          <el-radio :label="true">保留</el-radio>
          <el-radio :label="false">不保留</el-radio>
        </el-radio-group>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" class="mi-primary" @click="confirmStartover">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { formatDate } from '@/utils'
import { reset } from '@/api/merchant'
import Steps from '@/components/Steps.vue'
import StageFilling from '@/components/StageFilling.vue'
import StageAudit from '@/components/StageAudit.vue'
import StageAgreement from '@/components/StageAgreement.vue'
import StageEntered from '@/components/StageEntered.vue'

export default {
  components: {
    Steps,
    StageFilling,
    StageAudit,
    StageAgreement,
    StageEntered
  },
  data() {
    return {
      startoverDlg: {
        visible: false,
        value: true
      }
    }
  },
  computed: {
    ...mapState({
      enterState: 'enterState',
      steps: state => {
        const { operationLog } = state
        return [
          { title: '填写信息', desc: formatDate(operationLog.MERCHANT_FILL_IN) },
          { title: '资质审核', desc: formatDate(operationLog.CHECK), error: '审核不通过' },
          { title: '合作协议签署', desc: formatDate(operationLog.SIGN_CONTRACT), error: '合作协议签署失败', reject: true },
          { title: '入驻成功', desc: formatDate(operationLog.SIGN_E_SIGN), error: '签署失败' }
        ]
      },
      errorMsg: state => {
        const { signState, signData } = state
        if (!signState || !signData) return
        if (signState === 'OPERATION_CHECK_FAILED') return signData.operationCheckRemark
        if (signState === 'DEPARTMENT_CHECK_FAILED') return signData.departmentCheckRemark
        if (signState === 'E_SIGN_FAILED') return signData.eSignRemark
      },
      activeStep: state => {
        const { enterState } = state
        if (['FRESHMAN', 'IN_PROGRESS'].includes(enterState)) return { index: 0, status: 'process' }
        if (['CHECKING'].includes(enterState)) return { index: 1, status: 'process' }
        if (['NEED_MODIFY'].includes(enterState)) return { index: 1, status: 'error' }
        if (['SIGNING'].includes(enterState)) return { index: 2, status: 'process' }
        if (['SIGN_FAILED'].includes(enterState)) return { index: 2, status: 'error' }
        if (['ENTERED'].includes(enterState)) return { index: 3, status: 'success' }
      }
    })
  },
  methods: {
    // 显示重新入驻对话框
    showStartoverDlg() {
      this.startoverDlg.visible = true
    },
    // 确认重新入驻
    async confirmStartover() {
      try {
        const res = await reset({ keepData: this.startoverDlg.value })
        if (!res.code) {
          this.startoverDlg.visible = false
          location.href = '/'
        } else {
          this.$message.error(res.msg)
        }
      } catch (e) {
        this.$message.error('服务器错误')
      }
    }
  }
}
</script>

<style lang="less">
#apply {
  .steps-card {
    .steps {
      height: 124px;
      display: flex;
      justify-content: center;
      align-items: center;

      .el-steps {
        margin-top: 8px;
      }
    }

    .errors {
      text-align: center;
      font-size: 13px;
      color: #333333;
      line-height: 30px;
      padding-bottom: 15px;

      a {
        color: #457BFC;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }

      .error-msg {
        color: #FF7677;
      }
    }
  }

  .main {
    border-top: 8px solid #EFF0F4;
    min-height: 715px;

    .form-footer {
      margin: 30px 0;
    }
  }

  .startover-dlg {
    .content {
      padding-bottom: 20px;
      p {
        font-size: 13px;
        padding-bottom: 10px;
        color: #666;
      }
    }
    .dialog-footer {
      display: flex;
      justify-content: center;
    }
  }
}
</style>
